export default "__VITE_ASSET__mk9NNoYt__"